import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";
import { withRedirect } from "ui/layouts/Dashboard";

const Onboarding = () => null;

export default withRedirect(Onboarding, new Map([
    [RoleName.OnboardingE, () => WebRoutes.Onboarding.Merchant.Index],
    [RoleName.OnboardingO, () => WebRoutes.Onboarding.HighRiskMerchant.Index]
]));
